import React, { createContext, useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import { collection, onSnapshot } from "firebase/firestore";

export const UsuariosContext = createContext();

export const UsuariosProvider = ({ children }) => {
  // Inicializar el estado con los datos de localStorage
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    // Suscripción en tiempo real a la colección "usuarios"
    const unsubscribe = onSnapshot(collection(db, "usuarios"), (snapshot) => {
      const usuariosData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setUsuarios(usuariosData); // Actualizamos el estado con Firestore
    });

    return () => unsubscribe(); // Cleanup al desmontar
  }, []);

  return (
    <UsuariosContext.Provider value={usuarios}>
      {children}
    </UsuariosContext.Provider>
  );
};
